import { useState, useEffect, useCallback } from 'react';
import { substances } from '@Constants';
import Breadcrumb from '@Services/Breadcrumb';

export default function useGridView(activeBreadcrumb) {
  const [isGridView, setIsGridView] = useState(false);

  useEffect(() => {
    setIsGridView(activeBreadcrumb && activeBreadcrumb.context === substances && activeBreadcrumb.substanceGridView);
  }, [activeBreadcrumb]);

  const toggleGridView = useCallback(() => {
    const toggled = !isGridView;
    setIsGridView(toggled);
    // eslint-disable-next-line no-unused-vars
    const { resultsState, ...breadcrumd } = activeBreadcrumb;
    Breadcrumb.updateBreadcrumbs({ ...breadcrumd, substanceGridView: toggled });
  }, [activeBreadcrumb, isGridView]);

  return [isGridView, toggleGridView];
}
